import AOS from 'aos'
import React from 'react'
import WhatsappFixed from './components/whatsapp-fixed-icon';
import Routes from './routes';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from './styles/global';
import { Header } from './components/header';
import { useEffect, useState } from 'react';





interface IApp{
  eventOnScroll: ()=>boolean
}

function App({eventOnScroll}:IApp) {
  AOS.init();

  // You can also pass an optional settings object
  // below listed default settings
  AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    initClassName: 'aos-init', // class applied after initialization
    animatedClassName: 'aos-animate', // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
    
  
    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 400, // values from 0 to 3000, with step 50ms
    easing: 'ease', // default easing for AOS animations
    once: true, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
  
  });

  const [scrollDown, setScrollDown] = useState(false);
  

  useEffect(() => {
    // document.getElementById('root')?.removeEventListener('scroll', ()=>setScrollDown(eventOnScroll()));
    window.addEventListener('scroll', ()=>setScrollDown(eventOnScroll()))
    return () =>document.addEventListener('scroll', ()=>setScrollDown(eventOnScroll()));
  }, []);

  return (
    <BrowserRouter>
      <GlobalStyle/>
      <Header scrollDown={scrollDown}/>
      <Routes/>
      <WhatsappFixed/>
    </BrowserRouter>
  )
}

export default App
